import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import classNames from 'classnames';

import useClickOutside from '../../../../../../../../hooks/useClickOutside';

const propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultColor: PropTypes.string,
};

const CardDesignerCardElementColorControl = ({
  className,
  onChange,
  defaultColor = '',
}) => {
  const classes = classNames({
    'card-designer-card-element-color-control': true,
    [className]: !!className,
  });
  const ref = useRef(null);
  const [color, setColor] = useState(defaultColor);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(prev => !prev);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  useClickOutside(ref, () => {
    handleClose();
  });

  return (
    <div className={classes} ref={ref}>
      <button
        className={classNames({
          'card-designer-card-element-color-control-btn': true,
          'no-color': !color,
        })}
        onClick={handleClick}
        style={{ backgroundColor: color }}
      >
        Pick Color
        {color && <div className="picker-sample" />}
      </button>

      {displayColorPicker ? (
        <div className="card-designer-card-element-color-control-popover">
          <ChromePicker
            color={color}
            onChangeComplete={value => {
              setColor(value.hex);
              onChange(value.hex);
            }}
            disableAlpha
          />
        </div>
      ) : null}
    </div>
  );
};

CardDesignerCardElementColorControl.propTypes = propTypes;

export default CardDesignerCardElementColorControl;
